export const NODE_HEIGHT = 119;
export const NODE_WIDTH = 210;
export const NODE_MARGIN_TOP_BOTTOM = 30;
export const NODE_MARGIN_LEFT_RIGHT = 40;
export const LINK_OFFSET_TO_REACH_NODE_EDGE = 8;
export const NODE_MENU_SPACER = 30;
export const TRAINING_NODE_INPUT = 'training-node-input';
export const TRAINING_NODE_ERROR = 'training-node-error';
